import { memo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { isDashboardPathname } from '../../utils/dashboards';
import { FaHome, FaCog, FaSignOutAlt } from 'react-icons/fa';
import useLogout from '../../hooks/useLogout';

// Mobile is a monitor: only Home and Settings (preferences) exist here.
const tabs = [
	{ path: '/home', label: 'Dashboard', icon: FaHome },
	{ path: '/settings', label: 'Settings', icon: FaCog },
];

const MobileTabBar = () => {
	const handleLogout = useLogout();
	const { pathname } = useLocation();

	return (
		<nav className="mobile-tab-bar" aria-label="Main">
			{tabs.map(({ path, label, icon: Icon }) => (
				<NavLink
					key={path}
					to={path}
					className={({ isActive }) => {
						// /home forwards to /dashboards/:id, so the Dashboard tab must stay lit there too.
						const active = path === '/home' ? isDashboardPathname(pathname) : isActive;
						return `mobile-tab${active ? ' mobile-tab--active' : ''}`;
					}}
				>
					<Icon aria-hidden="true" />
					<span>{label}</span>
				</NavLink>
			))}
			<button type="button" className="mobile-tab mobile-tab--danger" onClick={handleLogout}>
				<FaSignOutAlt aria-hidden="true" />
				<span>Sign out</span>
			</button>
		</nav>
	);
};

export default memo(MobileTabBar);
